import {ReactNode} from 'react';
import styled, {css} from 'styled-components';

export interface IButtonProps {
  children: ReactNode;
  // brandOutline?: boolean;
  // primary?: boolean;
  // primaryOutline?: boolean;
  // secondary?: boolean;
}

export const FlexCentered = styled.div(
  props => `
    display:flex;
    align-items:center;
    `,
);

export const BaseColumnWrap = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:100%;
    `,
);

/** *** Button basic styles */

export const ButtonBase = styled.button(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border:none;
    background-color: ${props.theme.colors.goBrandOrange.base};
    color: ${props.theme.colors.goWhite.base};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    text-transform: uppercase;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    font-size:${props.theme.font.custom(16)};
    &:focus{
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
  `,
);

export const SectionHeader = styled.h3(
  props => `
    font-weight: bold;
    font-size: ${props.theme.font.custom(22)};
    font-family: ${props.theme.font.fontFamily};
    `,
);
/** ** anchor link *** */

export const PrimaryLink = styled.a(
  props => `
    color:${props.theme.colors.goBrandBlue.base};
  `,
);

// Button

const buttonDefaultStyles = css`
  display: flex;
  cursor: pointer;
  justify-content: center;
`;

export const PrimaryButton = styled.button<IButtonProps>(
  props => `
  ${buttonDefaultStyles}
  background-color: ${props.theme.colors.goBrandBlue.base};
  color: ${props.theme.colors.goWhite.base};
  padding: ${props.theme.spacing.custom(3)} ${props.theme.spacing.base};
  border: none;
  border-radius: ${props.theme.misc.borderRadius.base};
`,
);
